import { CommonModule } from '@angular/common';
import { Component, EventEmitter, input, Input, InputSignal, Output } from '@angular/core';
import { ClassInput } from '@feedonomics/frontend-components';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    standalone: true,
    selector: 'fdx-clearable-chip',
    templateUrl: './clearable-chip.component.html',
    styleUrl: './clearable-chip.component.scss',
    imports: [
        CommonModule,
        FontAwesomeModule,
        NgSelectModule
    ]
})
export class ClearableChipComponent {
    @Input() disabled: boolean = false;
    /** Renders the chip in the danger outline theme instead of the default secondary one. */
    readonly invalid: InputSignal<boolean> = input<boolean>(false);
    @Input() classes: ClassInput;
    @Output() readonly clear: EventEmitter<void> = new EventEmitter<void>();

    readonly closeIcon: IconDefinition = faTimes;
}
